import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Image, Input, Row } from "antd";
import { useNavigate } from "react-router-dom";
import CONSTANTS, { ROUTES, appRoot } from "../../../util/constant/CONSTANTS";
import useHttp from "../../../hooks/use-http";
import { getAuthToken, setAuthDetails } from "../../../util/API/authStorage";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import logo from "../../../asset/logos/Logo.png";

const LogIn = () => {
  const navigate = useNavigate();
  useEffect(() => {
  const isLogin = getAuthToken() !== undefined && getAuthToken() !== null;
  console.log(isLogin, "loh", getAuthToken());
  if (isLogin) {
    navigate(appRoot);
  }
  }, [navigate]);
  const api = useHttp();
  const [loadings, setLoadings] = useState([]);
  const validateLogin = (value) => {
    const payload = {
      email: value.email,
      password: value.password,
    };
      api.sendRequest(
        CONSTANTS.API.login,
        (res) => {
          setAuthDetails(res?.token,res?.admin);
          setLoadings([]);
          window.location.assign(appRoot);
        },
        payload,
        "LogIn Successful"
      );
  };
  const enterLoading = (index) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });
    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 3000);
  };
  return (
    <>
      <div
        className="h-screen flex justify-center items-center "
        style={{ background: "#121212" }}
      >
        <Row className="items-center md:gap-[90px]">
          <Col span={10} sm={24} xs={24} md={10} lg={10}>
            <div className="flex content-center justify-center">
              <Image
                src={logo}
                alt="Ceramic"
                preview={false}
                width={379}
                className="p-5"
              />
            </div>
          </Col>
          <Col span={14} sm={24} xs={24} md={11} lg={11}>
            <Card style={{ background: "#f1f1f1", border: "none" }}>
              <p className="text-3xl pl-4 font-medium	text-black">Login</p>           
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                  remember: true,
                }}
                onFinish={validateLogin}
              >
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your Email!",
                    },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined className="site-form-item-icon" />}
                    placeholder="Email"
                    type="email"
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your Password!",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    placeholder="Password"
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    loading={loadings[2]}
                    onClick={() => {
                      enterLoading(2);
                    }}                  
                  >
                    Log in
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default LogIn;
